import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { View, Text } from 'react-native';
import { useLazyQuery } from '@apollo/client';
import Table from './components/Table';
import { pageCount } from './functions/pagination';
import { useDefaults } from './Context';
export var Gql = function Gql(props) {
  var _useDefaults = useDefaults(props),
    query = _useDefaults.query,
    queryName = _useDefaults.queryName,
    entriesName = _useDefaults.entriesName,
    columns = _useDefaults.columns,
    lengthMenu = _useDefaults.lengthMenu,
    paginationLinks = _useDefaults.paginationLinks,
    queryVariables = _useDefaults.queryVariables,
    dataUpdated = _useDefaults.dataUpdated,
    setRefetch = _useDefaults.setRefetch,
    setSettings = _useDefaults.setSettings,
    movableColumns = _useDefaults.movableColumns,
    styles = _useDefaults.styles,
    component = _useDefaults.component,
    buttons = _useDefaults.buttons,
    htmlTable = _useDefaults.htmlTable,
    disableSearch = _useDefaults.disableSearch,
    alwaysSort = _useDefaults.alwaysSort,
    multiSort = _useDefaults.multiSort,
    sortOnArrowClickOnly = _useDefaults.sortOnArrowClickOnly,
    refetch = _useDefaults.refetch,
    copyComponent = _useDefaults.copyComponent,
    initialLoadComponent = _useDefaults.initialLoadComponent,
    isLoadingComponent = _useDefaults.isLoadingComponent,
    initialPageLength = _useDefaults.pageLength;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    variables = _useState2[0],
    setVariables = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    entries = _useState4[0],
    setEntries = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    count = _useState6[0],
    setCount = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    order = _useState8[0],
    setOrder = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    page = _useState10[0],
    setPage = _useState10[1];
  var _useState11 = useState('All' === initialPageLength ? 0 : initialPageLength || 10),
    _useState12 = _slicedToArray(_useState11, 2),
    pageLength = _useState12[0],
    setPageLength = _useState12[1];
  var _useState13 = useState(),
    _useState14 = _slicedToArray(_useState13, 2),
    searchTerm = _useState14[0],
    setSearchTerm = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    called = _useState16[0],
    setCalled = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    initialLoadCompleted = _useState18[0],
    setInitialLoadCompleted = _useState18[1];
  var _useLazyQuery = useLazyQuery(query, {
      fetchPolicy: 'network-only',
      onCompleted: function onCompleted(newData) {
        if (dataUpdated) {
          dataUpdated(newData);
        }
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getData = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    loading = _useLazyQuery2$.loading,
    data = _useLazyQuery2$.data,
    error = _useLazyQuery2$.error;
  var updateEntries = function updateEntries(options) {
    var newPage = options.newPage,
      newPageLength = options.newPageLength,
      newSearchTerm = options.newSearchTerm,
      newVariables = options.newVariables;
    var newOrder = options.newOrder;
    var limit = undefined === newPageLength ? pageLength : newPageLength;
    if (0 === limit) {
      limit = null;
    }
    var offset = (undefined === newPage ? page : newPage) * limit;
    var search = undefined === newSearchTerm ? searchTerm : newSearchTerm;
    var tableVariables = {
      limit: limit,
      offset: offset,
      search: search
    };
    if (multiSort) {
      tableVariables.order = undefined === newOrder ? order : newOrder;
    } else {
      if (newOrder) {
        tableVariables.sort = newOrder[0] ? newOrder[0].key : undefined;
        tableVariables.sortDirection = newOrder[0] ? newOrder[0].direction : undefined;
      } else {
        tableVariables.sort = order[0] ? order[0].key : undefined;
        tableVariables.sortDirection = order[0] ? order[0].direction : undefined;
      }
    }
    getData({
      variables: _objectSpread(_objectSpread({}, tableVariables), newVariables || variables || {})
    });
    if (undefined !== newVariables) {
      setVariables(newVariables);
    }
    ;
    if (undefined !== newOrder) {
      setOrder(newOrder);
    }
    if (undefined !== newPage) {
      setPage(newPage);
    }
    if (undefined !== newPageLength) {
      setPageLength(newPageLength);
    }
    if (undefined !== newSearchTerm) {
      setSearchTerm(newSearchTerm);
    }
    if (setSettings) {
      setSettings({
        search: search,
        order: newOrder || order
      });
    }
  };
  useEffect(function () {
    var newOrder = [];
    columns.forEach(function (column) {
      if ('asc' === column.sort) {
        newOrder.push({
          key: column.key,
          direction: 'asc'
        });
      } else if ('desc' === column.sort) {
        newOrder.push({
          key: column.key,
          direction: 'desc'
        });
      }
    });
    updateEntries({
      newOrder: newOrder,
      newVariables: queryVariables
    });
    setRefetch(function () {
      return function () {
        return updateEntries({
          newVariables: queryVariables
        });
      };
    });
  }, []);
  useEffect(function () {
    if (data && JSON.stringify(queryVariables) !== JSON.stringify(variables)) {
      updateEntries({
        newVariables: queryVariables
      });
    }
  }, [queryVariables, variables]);
  if (data && data[queryName]) {
    // Save entries and count to state to avoid jumpiness when updateEntries
    // fetches new data (due to table rows disappearing).
    var dataEntries = data[queryName][entriesName || 'entries'];
    if (JSON.stringify(dataEntries) !== JSON.stringify(entries)) {
      setEntries(dataEntries);
    }
    if (data[queryName].count != count) {
      setCount(data[queryName].count);
      var maxPage = pageCount(data[queryName].count, pageLength) - 1;
      if (maxPage < page) {
        updateEntries({
          newPage: maxPage
        });
      }
    }
  }
  if (!initialLoadCompleted) {
    if (data) {
      setInitialLoadCompleted(true);
    }
    return /*#__PURE__*/React.createElement(View, null, initialLoadComponent || /*#__PURE__*/React.createElement(Text, null, "Loading..."));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(View, {
    style: {
      borderWidth: 2,
      borderColor: 'red'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: {
      fontSize: 18
    }
  }, "Error: ", error.message)), /*#__PURE__*/React.createElement(Table, {
    entries: entries,
    columns: columns,
    order: order,
    updateEntries: updateEntries,
    page: page,
    count: count,
    lengthMenu: lengthMenu,
    pageLength: pageLength,
    paginationLinks: paginationLinks,
    searchTerm: searchTerm,
    movableColumns: movableColumns,
    styles: styles,
    component: component,
    buttons: buttons,
    htmlTable: htmlTable,
    disableSearch: disableSearch,
    alwaysSort: alwaysSort,
    multiSort: multiSort,
    sortOnArrowClickOnly: sortOnArrowClickOnly,
    isLoading: loading,
    isLoadingComponent: isLoadingComponent,
    copyComponent: copyComponent,
    refetch: false === refetch ? false : function () {
      setEntries([]);
      updateEntries({});
    }
  }));
};
export default Gql;